/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facetemplete-phone': {
    width: 20,
    height: 20,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M2.667 5.324A1.333 1.333 0 0 1 3.989 4h24.022c.731 0 1.323.593 1.323 1.324v21.352A1.333 1.333 0 0 1 28.012 28H3.99a1.324 1.324 0 0 1-1.323-1.324V5.324zM16 6.667v18.667h10.667V6.667H16zm1.333 2.666h8V12h-8V9.333zm0 4h8V16h-8v-2.667z"/>'
  }
})
